module.exports = __webpack_public_path__ + "static/img/Stack.80e4756c.svg";